import { lazy } from 'react';

export { default as routes } from './routes';

export const AccountSettingsFeature = lazy(() => import('./pages/AccountSettings/AccountSettings'));
